import { View, TextView, AmbassadorView } from "@gaming/srvg-classes-core";
import { Chunk } from "../Data/Chunk";


export class ChunkIndicatorView extends View {
    chunk: Chunk;
    competitionView: TextView;
    sporteventSetView: TextView;
    chunkView: TextView;
    ambassadorView: AmbassadorView;
    authorityCodeView: TextView;
    authorityCode: number;

    constructor( options ) {
        options = options || {};
        super( options );
        this.competitionView = this.addSubView( new TextView( { selector: this.selector + ' .competition' } ) );
        this.sporteventSetView = this.addSubView( new TextView( { selector: this.selector + ' .sporteventset' } ) );
        this.chunkView = this.addSubView( new TextView( { selector: this.selector + ' .chunk' } ) );
        this.ambassadorView = this.addSubView( new AmbassadorView( { selector: this.selector + ' .AmbassadorView', product: srvg.product.name } ) );
        this.authorityCodeView = this.addSubView( new TextView( { selector: this.selector + ' .authorityCode' } ) );
        this.chunk = null;
        this.authorityCode = null;
    }

    setChunk( chunk: Chunk ){
        this.chunk = chunk;
        this.refresh();
    }

    refresh() {
        if( ! this.chunk  ){
            return;
        }

        this.competitionView.setText(  this.chunk.getCompetitionName() );

        // set chunk texts
        this.sporteventSetView.setText( this.chunk.getName() );
        this.chunkView.setText( this.chunk.getDescription() );

        this.ambassadorView.refresh();
    }

    setAuthorityCode(authorityCode){
        if (authorityCode != this.authorityCode) {
            authorityCode = parseInt(authorityCode, 10);
            if(authorityCode > 0){
                this.authorityCode = authorityCode;

                $(this.selector).addClass('withAuthorityCode');
                this.authorityCodeView.setText(__('Pal.') + ': ' + this.authorityCode);
            }else{
                this.authorityCode = null;

                $(this.selector).removeClass('withAuthorityCode');
                this.authorityCodeView.setText('');
            }
        }
    }
}